import React from 'react';
import MyCustomLogoFull from './nees1.png';


const LogoFull = () => {
  return <img src={MyCustomLogoFull} />;
};

export default LogoFull;
